import usePermissions from "../../../../services/Permissions";
import {useDispatch, useSelector} from "react-redux";
import React, {useEffect, useMemo, useState} from "react";
import {t} from "../../../../services/i18n";
import {
    dbDateFormat,
    getGroupLinkContactHelper,
    getLocale,
    isActive,
    openLimitedPackageModal,
    openUpgrade360Link
} from "../../../../services/Helpers";
import {fetchApi} from "../../../../services/HTTP";
import FormInput from "../../../common/FormInput";
import SimpleInput from "../../../common/SimpleInput";
import {Box, Button, HStack, Spinner, VStack} from "native-base";
import {Flex, Radio} from "antd";
import AppText from "../../../common/AppText";
import InfoTooltip from "../../../common/InfoTooltip";
import AdvanceSelect from "../../../common/AdvanceSelect";
import {EMAIL, ITEMS_SELECT, MESSAGE_TEMPLATE_SELECT, SMS} from "../../../../services/ConstHelper";
import CustomCheckbox from "../../../common/CustomCheckbox";
import {Colors} from "../../../../styles/Colors";
import CustomButtonV2 from "../../../common/CustomButtonV2";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import _ from "lodash";
import groupBy from 'lodash-es/groupBy';
import MessageTextFormInput from "../../../common/MessageTextFormInput";
import {checkRequired} from "../../../../services/stepperService";
import {MembershipTypes, MetaWhatsappTemplateStatus} from "../../../../Configs/DatabaseConsts";
import SharedTimepicker from "../../../common/SharedTimepicker";
import moment from "moment/moment";

const SendLink = (props) => {
    const { handleChange, values, touched, errors, target, setFieldValue, displayProps, validationObject } = props;
    const {has, hasLock} = usePermissions()
    const dispatch = useDispatch()
    const box = useSelector(state => state.box?.box)
    const isIL = box?.locations_box[0]?.country_code === 'IL';
    const [smsBalance, setSmsBalance] = useState(null);
    const [membershipTypesShowInApp, setMembershipTypesShowInApp] = useState([])
    const [membershipTypesHideInApp, setMembershipTypesHideInApp] = useState([])
    const [selectedTemplate, setSelectedTemplate] = useState(null)
    const hasPackage = !/.*(free|trial)+.*/g.test(box?.packages?.name?.toLowerCase());
    const hasWhatsapp = useMemo(() => box?.integrations?.find(i => i.name === 'upgrade360' || i.name === 'greenApi' || i.name === 'metaWhatsapp'), [box]);
    const hasMetaWhatsapp = useMemo(() => box?.integrations?.some((i) => i.name === 'metaWhatsapp'), [box?.integrations]);
    const specificTarget = useMemo(() => target?.type === 'reports' ? Object.keys(target.selectedUsers) : null, [target?.selectedUsers, target?.type])
    const hasEmptyTargetArrays = useMemo(() => {
        if(target?.type === 'reports') {
            if(values.membership_user_id && values.membership_user_id?.length === 0) return true
            if(specificTarget?.length === 0) return true
        }
        return false
    }, [target?.type, values.membership_user_id])
    const charCount = values.message_content?.length || 0;
    const smsUnitCount = isIL ? 133 : 70;
    const [messageTemplates] = useState(box.message_template?.filter(template => isActive(template) && !template.scope)?.map(template => ({...template, value: template.id, label: template.name, text: template.text.replace('{{#firstName#}}', `[${t('firstName')}]`).replace('{{#lastName#}}', `[${t('lastName')}]`)})))
    const tags = displayProps.tags

    const metaApprovedTemplate = useMemo(() => {
        if (!hasMetaWhatsapp || !displayProps.metaWhatsappTemplateEvent) return null;
        const langCode = (box?.language || '').substring(0, 2).toLowerCase();
        const suffix = langCode === 'he' || (!langCode && isIL) ? 'HE' : 'EN';
        const templateName = `${displayProps.metaWhatsappTemplateEvent}WhatsappTemplate_${suffix}`;
        return box.message_template?.find((template) =>
            template.name === templateName
            && template.scope === 'system'
            && template.active == 1
            && template.whatsapp_template?.status == MetaWhatsappTemplateStatus.APPROVED
        ) || null;
    }, [hasMetaWhatsapp, displayProps.metaWhatsappTemplateEvent, box?.message_template, box?.language, isIL]);

    const isMetaLinkLocked = hasMetaWhatsapp && values.send_whatsapp && !!metaApprovedTemplate;
    const metaWhatsappOn = hasMetaWhatsapp && displayProps.metaWhatsappTemplateEvent && values.send_whatsapp;

    useEffect(() => {
        fetchItems()
    }, [])

    const onTagClick = (label) => {
        if (isMetaLinkLocked) return;
        if (`${values.message_content || ''} [${label}]`.length <= 320) {
            setFieldValue('message_content', `${values.message_content || ''}[${label}]`)
        }
        document?.getElementById('text-area-message')?.focus()
    }

    useEffect(() => {
        getSmsBalance()
    }, []);

    const groupHelper = useMemo(() => {
        if (!has('groupActions') || target?.type === 'reports') return null
        const userFk = values.user_fk ?? target?.user?.user_fk
        return getGroupLinkContactHelper({
            connections: target?.groupData,
            memberUserFk: userFk,
            includePhone: !!(values.send_sms || values.send_whatsapp),
            includeEmail: !!values.send_email,
        })
    }, [target?.groupData, values.user_fk, values.send_sms, values.send_whatsapp, values.send_email]);

    const openLockPopup = () => {
        openLimitedPackageModal(dispatch)
    }

    const applyMetaApprovedTemplate = () => {
        if (!metaApprovedTemplate) return;
        let text = metaApprovedTemplate.text || '';
        (tags || []).forEach((tag) => {
            text = text.replaceAll(`{{#${tag.id}#}}`, `[${tag.label}]`);
        });
        setFieldValue('message_content', text);
        setFieldValue('message_template_id', metaApprovedTemplate.id);
    };

    const handleWhatsappClick = async (val) => {
        if (!hasWhatsapp) {
            openUpgrade360Link()
        } else {
            setFieldValue('send_whatsapp', val);
            if (hasMetaWhatsapp && displayProps.metaWhatsappTemplateEvent) {
                if (val) {
                    setFieldValue('send_sms', false);
                    setFieldValue('send_email', false);
                    setFieldValue('send_push', false);
                }
                if (val && metaApprovedTemplate) {
                    applyMetaApprovedTemplate();
                } else {
                    setFieldValue('message_template_id', null);
                }
            }
        }
    }
    const handleEmailClick = async (val) => {
        if (hasLock('emailActions')) {
            openLockPopup()
        } else {
            setFieldValue('send_email', val)
        }
    }

    const getSmsBalance = async () => {
        const res = await fetchApi('boxes/getSmsBalance', 'POST', null, false, true);
        setSmsBalance(res || 0);
    }

    const fetchItems = async () => {
        try {
            if (displayProps.hideMembershipSelect) return
            const withHug = has('hugim');

            // show_in_app = 1
            const showRaw = await fetchApi('membership/searchForMembershipTypes', 'post', {show_in_app: 1, withHug}, false, true);
            filterAndSortItems(formatMembershipOptions(showRaw), setMembershipTypesShowInApp);

            // show_in_app = 0
            const hideRaw = await fetchApi('membership/searchForMembershipTypes', 'post', {show_in_app: 0, withHug}, false, true);
            filterAndSortItems(formatMembershipOptions(hideRaw), setMembershipTypesHideInApp);
        } catch (e) {
            console.error('fetchItems error', e);
        }
    };

    const applyDisplayFilter = (items) => {
        if (displayProps.showOnlyPlanAndSessionPacks) {
            return items.filter(m => m.type === MembershipTypes.PLAN || m.type === MembershipTypes.SESSION);
        }
        if (displayProps.showOnlyItems) {
            return items.filter(m => m.type === MembershipTypes.ITEM);
        }
        if (displayProps.showOnlyHugim) {
            return items.filter(m => m.type === MembershipTypes.RECURRING || m.type === MembershipTypes.REGULAR);
        }
        if(displayProps.hideNewUsersMemberships) {
            return items.filter(membership => !membership.new_users_membership_prop_exists)
        }
        return items;
    };

    const formatMembershipOptions
        = (items) =>
        applyDisplayFilter(items).map(res => ({
            ...res,
            name: res.name + getPaymentTypeForHugim(res.type),
        }));

    const getPaymentTypeForHugim = (type) => {
        if(type === "regular") {
            return ` (${t('regularPayment')})`
        } else if (type === 'recurring') {
            return ` (${t('recurringPayment')})`
        } else {
            return ''
        }
    }

    const filterAndSortItems = (items, setFunc) => {
        let results = items.reduce((acc, item) => [...acc, {...item, label: item.name, value: item.id}],[]);

        results = _.sortBy(results, [
            (item) => {
                if (/^[A-Za-z]/.test(item.name)) return 1;
                if (/^[\u0590-\u05FF]/.test(item.name)) return 2;
                if (/^\d/.test(item)) return 3;
                return 4;
            },
            (item) => item.name.toLowerCase()
        ]);
        results = groupItems(results)
        setFunc(results)
    }

    const groupItems = (options) => {
        let group = groupBy(options, item => {
            if (item.type === 'regular') return 'recurring';
            return item.type;
        })
        const res = Object.keys(group).reduce((acc, groupKey) => ({...acc, [groupKey]: {...acc[groupKey], options: group[groupKey]}}),
            {
                'plan': {
                    label: t('planItemsSelect'),
                    options: []
                },
                'session': {
                    label: t('sessionItemsSelect'),
                    options: []
                },
                'item': {
                    label: t('productItemsSelect'),
                    options: []
                },
                'recurring': {
                    label: t('hugimItemsSelect'),
                    options: []
                }
            })
        return Object.values(res);
    }

    const onMembershipTypeChange = (data) => {
        if(data) {
            if(data?.type === MembershipTypes.RECURRING || data?.type === MembershipTypes.REGULAR) {
                setFieldValue('item_id', data?.series_id)
            } else {
                setFieldValue('item_id', data?.id)
            }
            setFieldValue('item_type', data?.type)
            setFieldValue('membership_type', data?.label)
        } else {
            setFieldValue('item_id', null)
            setFieldValue('item_type', null)
            setFieldValue('membership_type', null)
        }
    }

    const onChooseTemplate = (option) => {
        setSelectedTemplate(option.name)
        setFieldValue('digital_form_id', option.digital_form_id)
        setFieldValue('scope', option.scope)
        setFieldValue('message_content', option.text)
        setFieldValue('subject', option.subject || '');
    }

    useEffect(() => {
        if(specificTarget) {
            setFieldValue('users', specificTarget)
        }
    }, [specificTarget])

    const getPlaceholder = () => {
        if(displayProps.showOnlyHugim) return t('selectHugForPurchaseLeadProfile')
        if(displayProps.showOnlyItems) return t('selectItemForPurchaseLeadProfile')
        return displayProps.showOnlyPlanAndSessionPacks ? t('selectMembershipLinkToConvert'): (has('hugim') ? t('selectItemForPurchaseWithHugim') : t('selectItemForPurchase'))
    }

    return (
        <>
            {/* user */}
            {target?.type === 'reports' ?
                <FormInput
                    label={t('targetAudience')}
                    value={t('membersChosen', {membersNum: hasEmptyTargetArrays ? 0 : specificTarget.length})}
                    width={'100%'}
                    containerProps={{ mb: '2rem' }}
                    helper={has('groupActions') && t('target-audience-group-helper')}
                    disabled
                    error={errors.membership_user_id ?? (hasEmptyTargetArrays && displayProps.emptyUsersError)}
                />
                :
            <FormInput
                label={t('specific-user')}
                width={'100%'}
                containerProps={{ mb: '24px' }}
                helper={groupHelper && groupHelper.severity !== 'error' ? groupHelper.text : false}
                helperProps={groupHelper?.severity === 'warning' ? { color: Colors.newDesign.darkOrange } : {}}
                error={(touched.user_fk && errors.user_fk) || (groupHelper?.severity === 'error' ? groupHelper.text : null)}>
                <SimpleInput value={target.user?.full_name} disabled />
            </FormInput>}
            {/* item */}
            {!displayProps?.hideMembershipSelect &&
            <FormInput label={t('chooseItemToSend')+checkRequired('item_id', validationObject)} containerProps={{mb: '24px'}} infoTooltip={displayProps.membershipSelectionTooltip && t('chooseItemInfo')}
                        error={(!values.item_id && errors.item_id && touched.item_id ? errors.item_id : '')}>
                <VStack space={'9px'}>
                    <HStack>
                        <HStack>
                            <Radio.Group value={values.available_on_app} onChange={(e) => {
                                setFieldValue('available_on_app', e.target.value)
                                setFieldValue('item_id', null)
                            }}>
                                <HStack space={'1.2rem'}>
                                    <Radio value={true} size="sm">
                                        <AppText>{t('availableOnApp')}</AppText>
                                    </Radio>
                                    <Radio value={false} size="sm">
                                        <HStack>
                                            <AppText>{t('notAvailableOnApp')}</AppText>
                                            <InfoTooltip title={t('sendMembershipLinkInfo')}/>
                                        </HStack>
                                    </Radio>
                                </HStack>
                            </Radio.Group>
                        </HStack>
                    </HStack>
                    <Box flexGrow={1}>
                        <AdvanceSelect dontSort isClearable={true}
                                       options={values.available_on_app ? membershipTypesShowInApp : membershipTypesHideInApp}
                                       initValue={values.item_id} type={ITEMS_SELECT} onChange={onMembershipTypeChange}
                                       placeholder={getPlaceholder()}
                                       showInApp={values.available_on_app ? 1 : 0}
                                       isError={!values.item_id && errors.item_id && touched.item_id}/>
                    </Box>
                </VStack>
            </FormInput>}
            {/* types */}
            <FormInput label={t('message-type')+checkRequired('send_push', validationObject)} containerProps={{ mb: '24px' }} error={(touched.send_sms && errors.send_sms) || null}>
                {displayProps.showPushOption && <HStack>
                    <CustomCheckbox text={t('send-via-push')} isChecked={values.send_push} disabled={metaWhatsappOn}
                                    style={metaWhatsappOn ? { opacity: 0.5 } : {}}
                                    onChange={val => setFieldValue('send_push', val)}/>
                </HStack>}
                <HStack>
                    <CustomCheckbox text={
                        <HStack space={'0.2rem'} alignItems={'center'} height={'1.8rem'}>{t('send-via-sms') + ' '} {
                            <HStack alignItems={'center'}>
                                ({smsBalance !== null ? <AppText>{`${t('your-text-message-balance')}: ${smsBalance?.toLocaleString(getLocale()) || 0}. `}</AppText> : <Spinner color={Colors.newDesign.darkGrey} />}
                                <CustomButtonV2 onClick={() => window.open('/reports-v5/communication?action=smsPurchasePage', '_blank')}
                                                type={'link'}
                                                style={{ width: 'max-content' }}
                                                text={t('purchase-more')}
                                                textProps={{ color: Colors.newDesign.mainBlue }}
                                />
                                )</HStack>
                        }</HStack>
                    } isChecked={values.send_sms} disabled={metaWhatsappOn} style={metaWhatsappOn ? { opacity: 0.5 } : {}}
                      onChange={val => setFieldValue('send_sms', val)} />
                </HStack>
                {has('emailActions') &&
                    <HStack>
                        <CustomCheckbox style={(hasLock(`emailActions`) || metaWhatsappOn) ? { opacity: 0.5 } : {}}
                                        disabled={metaWhatsappOn} text={
                            <HStack height={'1.8rem'} alignItems={'center'} space={'0.4rem'}>{t('send-via-email')}{hasLock(`emailActions`) && <FontAwesomeIcon icon={'fa-light fa-lock-keyhole'} />}</HStack>
                        } isChecked={values.send_email} onChange={handleEmailClick} />
                    </HStack>}
                {(isIL || has('viewUpgrade360')) && hasPackage && !displayProps?.hideWhatsappOption &&
                    <HStack>
                        <CustomCheckbox
                            disabled={!hasWhatsapp}
                            style={!hasWhatsapp ? { opacity: 0.5 } : {}}
                            text={<CustomButtonV2 onClick={() => !hasWhatsapp && handleWhatsappClick()} override={() => <HStack height={'1.8rem'} alignItems={'center'} space={'0.4rem'}>
                                {t('send-via-whatsapp')}{!hasWhatsapp && <FontAwesomeIcon icon={'fa-light fa-lock-keyhole'} style={{opacity: '0.5'}}/>}
                            </HStack>} />}
                            isChecked={values.send_whatsapp}
                            onChange={handleWhatsappClick}
                        />
                    </HStack>}
            </FormInput>
            {/* expiration date - kiosk aka debt link */}
            {('expiration_date' in values) &&
            <VStack>
                <FormInput containerProps={{ mb: '24px' }} width={'fit-content'} label={t('link-expiration-date-label')+checkRequired('expiration_date', validationObject)} error={(touched.expiration_date && errors.expiration_date) ? errors.expiration_date : null}>
                    <SharedTimepicker type={'date'}
                                      isError={(touched.expiration_date && errors.expiration_date) ? errors.expiration_date : null}
                                      value={values.expiration_date ? moment(values.expiration_date, dbDateFormat) : null}
                                      inputStyle={[{width: 'fit-content'}]}
                                      onChange={(expiration_date) => setFieldValue('expiration_date', expiration_date ? expiration_date.format(dbDateFormat) : null)}
                    />
                </FormInput>
            </VStack>}
            {/* expiration date - kiosk aka debt link */}
            {('max_installments' in values) &&
                <VStack>
                    <FormInput containerProps={{ mb: '24px' }}
                               onChangeCallback={(val) => setFieldValue('max_installments', val)}
                               numericOnly={true}
                               value={values.max_installments}
                               width={'3.5rem'}
                               label={t('max-installments-label')+checkRequired('max_installments', validationObject)}
                               error={(touched.max_installments && errors.max_installments) ? errors.max_installments : null}/>
                </VStack>
            }
            {/* template */}
            <FormInput containerProps={{ mb: '24px' }} label={t('template')} width={'100%'} >
                {isMetaLinkLocked
                    // Same as Angular auto-actions: lang[systemTemplate.name]
                    ? <SimpleInput value={t(metaApprovedTemplate.name)} disabled />
                    : <AdvanceSelect dontSort type={MESSAGE_TEMPLATE_SELECT} options={messageTemplates} initValue={selectedTemplate} onChange={onChooseTemplate} />
                }
            </FormInput>
            {/* subject */}
            {has('emailActions') && !hasLock('emailActions') && <FormInput
                label={t('subject')+checkRequired('subject', validationObject)}
                value={values.subject}
                onChangeCallback={handleChange('subject')}
                error={(touched.subject && errors.subject) || null}
                width={'100%'}
                maxLength={40}
                showCount
                containerProps={{ mb: '24px' }}
                placeholder={t(`subject-email`)}
                disabled={metaWhatsappOn}
            />}
            {/* message content */}
            <MessageTextFormInput {...{tags, onTagClick, setFieldValue, values, maxLength: 320,
                touched, errors, name: 'message_content', placeholder: t('add-message-here'), id: 'text-area-message',
                isSms: values.send_sms, showDigitalFormText: values.digital_form_id, charCount, maxCharCount: 320, smsUnitCount, validationObject,
                disabled: isMetaLinkLocked, infoTooltip: isMetaLinkLocked ? t('disabled-meta-template-link-message-tooltip') : undefined}}/>
        </>
    );
}

export default SendLink